import React from "react";
import { Link } from "react-router-dom";

const BannerWithProducts = ({ banner, products = [] }) => {
  return (
    <section className="flat-spacing-12 pt_0">
      <div className="container">
        <div className="row align-items-center flex-md-row-reverse">
          <div className="col-md-6">
            {banner && (
              <div className="collection-item-v2 hover-img">
                <Link
                  to={banner.link || "/shop/collection"}
                  className="collection-inner"
                >
                  <div className="collection-image img-style">
                    <img
                      className="lazyload"
                      data-src={banner.image}
                      src={banner.image}
                      alt={banner.alt || "collection-img"}
                    />
                  </div>
                  <div className="collection-content justify-content-end">
                    <div className="bottom wow fadeInUp" data-wow-delay="0s">
                      {banner.title && (
                        <h5 className="heading text-white fw-7">
                          {banner.title}
                        </h5>
                      )}
                      {banner.subtitle && (
                        <p className="subheading text-white">
                          {banner.subtitle}
                        </p>
                      )}
                      {banner.buttonText && (
                        <button className="tf-btn btn-line btn-line-light collection-other-link fw-6">
                          <span>{banner.buttonText}</span>
                          <i className="icon icon-arrow1-top-left"></i>
                        </button>
                      )}
                    </div>
                  </div>
                </Link>
              </div>
            )}
          </div>
          <div className="col-md-6">
            <div className="tf-grid-layout tf-col-2 gap30 row-gap-10">
              {products.map((product, index) => (
                <div key={index} className="card-product">
                  <div className="card-product-wrapper rounded-0">
                    <Link
                      to={`/shop/default?offer_id=${product.id}`}
                      className="product-img"
                    >
                      <img
                        className="lazyload img-product"
                        data-src={product.image}
                        src={product.image}
                        alt={product.name || "image-product"}
                      />
                      <img
                        className="lazyload img-hover"
                        data-src={product.hoverImage || product.image}
                        src={product.hoverImage || product.image}
                        alt={product.name || "image-product"}
                      />
                    </Link>
                    {product.discount && (
                      <div className="on-sale-wrap text-end">
                        <div className="on-sale-item">{product.discount}</div>
                      </div>
                    )}
                  </div>
                  <div className="card-product-info">
                    <Link
                      to={`/shop/default?offer_id=${product.id}`}
                      className="title link fw-8"
                    >
                      {product.name}
                    </Link>
                    <span className="price fw-6">{product.price}</span>
                    {product.colors && product.colors.length > 0 && (
                      <ul className="list-color-product">
                        {product.colors.map((color, colorIndex) => (
                          <li
                            key={colorIndex}
                            className={`list-color-item color-swatch ${
                              colorIndex === 0 ? "active" : ""
                            }`}
                          >
                            <span className="tooltip">{color.name}</span>
                            <span
                              className={`swatch-value ${
                                color.className || ""
                              }`}
                            ></span>
                            {color.image && (
                              <img
                                className="lazyload"
                                data-src={color.image}
                                src={color.image}
                                alt={color.name}
                              />
                            )}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerWithProducts;
